import { useMemo } from 'react'

import { ImportedInvoiceReviewTotals } from '@features/importedInvoices/types/importedInvoiceLineAmounts'
import { ImportedInvoiceReviewFormSchema } from '@features/importedInvoices/types/importedInvoiceReviewFormSchema'
import { getImportedInvoiceReviewTotals } from '@features/importedInvoices/utils/getImportedInvoiceReviewTotals'
import { getImportedInvoiceVatRate } from '@features/importedInvoices/utils/getImportedInvoiceVatRate'
import { useTaxRates } from '@modules-deprecated/app/taxrates'

import { useFormContext, useWatch } from '../../../../../../../hooks/useForm'

export const useImportedInvoiceReviewTotals = (): ImportedInvoiceReviewTotals => {
  const { control } = useFormContext<ImportedInvoiceReviewFormSchema>()
  const [lines, currency] = useWatch({ control, name: ['lines', 'currency'] })
  const { taxRatesIncludingDeactivated } = useTaxRates()

  return useMemo(() => {
    const linesWithRates = (lines ?? []).map((line) => ({
      amountExclVat: line.amountExclVat,
      vatRate: getImportedInvoiceVatRate(taxRatesIncludingDeactivated, line.vatRateId),
    }))

    return getImportedInvoiceReviewTotals(linesWithRates, currency)
  }, [currency, lines, taxRatesIncludingDeactivated])
}
